import { FC, Fragment, useEffect, useState } from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { FormObjSwitch } from "Utils/SwitchCases";
import CommonFormatter from "Utils/Common.Formatter";
import { FormObjType } from "DataTypes/Form";
import { EditForm } from "./Data";
import { CommonStyle } from "Components";
import ImgPath from "Constant/Imgs";
import CstmBtn from "Components/CstmBtn";
import { PatientInitialStateType, UserInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";
import RedoxApi from "Service/Redox.api";
import { useDispatch } from "react-redux";
import { addPatientInfo } from "Redux/Patient/Action";
import { CheckStringEmpty, FormatSysMobileNo } from "Utils/common";
import { setAlertData, setFormLoader } from "Redux/Screen/Action";
import DateTime from "Utils/DateTime";

interface AddEditViewModalProps {
  onClose: () => void;
}

const EditProfile: FC<AddEditViewModalProps> = (props) => {
  const { onClose } = props;
  const dispatch = useDispatch()
  const { patientInfo }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const isAdmin = myInfo.roleId == 1 || myInfo.roleId == 2;
  const [formData, setFormData] =
    useState<FormObjType[]>(JSON.parse(JSON.stringify(EditForm)));

  useEffect(() => {
    handleLoadData();
  }, []);

  const handleLoadData: () => void = () => {
    let newFormData: FormObjType[] = JSON.parse(JSON.stringify(EditForm));
    const newPatientData = JSON.parse(JSON.stringify(patientInfo));
    newFormData = newFormData.map(el => {
      if (
        !isAdmin &&
        (el.id == "firstName" ||
          el.id == "middleName" ||
          el.id == "lastName" ||
          el.id == "dob")
      ) el.readOnly = true;
      if (el.id == "home" || el.id == "mobile") {
        el.inputVal = FormatSysMobileNo(newPatientData[el.id]) ?? "";
      } else el.inputVal = newPatientData[el.id] ?? "";
      return el;
    })
    setFormData(newFormData);
  };

  const handleUpdateDetails: () => void = async () => {
    const formValidate = CommonFormatter.HandleValidateForm(formData);
    setFormData(formValidate.formData);
    if (!formValidate.errorCheck) {
      dispatch(setFormLoader(true));
      const payload = {
        firstName: CheckStringEmpty(formData[0].inputVal),
        middleName: CheckStringEmpty(formData[1].inputVal),
        lastName: CheckStringEmpty(formData[2].inputVal),
        dob: DateTime.ToLocalDate(CheckStringEmpty(formData[3].inputVal)),
        houseNumber: CheckStringEmpty(formData[4].inputVal).replace("-", ""),
        mobile: CheckStringEmpty(formData[5].inputVal).replace("-", ""),
        email: CheckStringEmpty(formData[6].inputVal),
        language: CheckStringEmpty(formData[7].inputVal),
        streetAddress: CheckStringEmpty(formData[8].inputVal),
        address2: CheckStringEmpty(formData[9].inputVal),
        city: CheckStringEmpty(formData[10].inputVal),
        state: CheckStringEmpty(formData[11].inputVal),
        zip: CheckStringEmpty(formData[12].inputVal),
      }
      const res = await RedoxApi.PatientDetailsUpdate({
        id1: patientInfo.id, data: payload
      });
      if (res?.success) {
        dispatch(addPatientInfo({
          ...patientInfo,
          ...payload,
        }));
        dispatch(setAlertData(res?.alert));
      }
      dispatch(setFormLoader(false));
    }
  };

  return (
    <Fragment>
      <Box sx={{ ...sxHeader, ...CommonStyle.sxRow }}>
        <Typography fontWeight="bold" textTransform="capitalize">
          Edit Profile
        </Typography>
        <Box display={"flex"} alignItems={"center"}>
          <Box
            sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
            onClick={onClose}
          >
            <ImgPath.CloseIcon titleAccess="Close" />
          </Box>
        </Box>
      </Box>
      <Box sx={{ ...sxMain }}>
        <Grid container rowSpacing={1} columnSpacing={2}>
          {formData.map((el) => {
            return (
              <Grid
                key={el.id}
                item
                {...{ md: el.boxSize, lg: el.boxSize, xl: el.boxSize }}>
                {FormObjSwitch({
                  formObj: el,
                  onClick: async (props) => {
                    setFormData(
                      CommonFormatter.HandleClickChange(props, formData)
                    );
                  },
                  inputChange: async (props) => {
                    setFormData(
                      CommonFormatter.HandleInputChange(props, formData)
                    );
                  },
                })}
              </Grid>
            );
          })}
        </Grid>
        <Divider sx={{ my: 2 }} />
        <Box
          display="flex"
          justifyContent="flex-end"
          sx={{ "&>button": { ml: 1 } }}
        >
          <CstmBtn
            label={"Save"}
            onClick={handleUpdateDetails}
            enableFormLoad={true}
          />
          <CstmBtn label={"Close"} onClick={onClose} btnType="border" />
        </Box>
      </Box>
    </Fragment>
  );
};

export default EditProfile;

const sxHeader = {
  justifyContent: "space-between",
  height: "8%",
  px: 2,
};

const sxMain = {
  height: "85%",
  overflow: "auto",
  px: 2,
};
